import { createRouter, createWebHistory } from 'vue-router'
import useFunctions from '@/composables/useFunctions'

import authRouter from '../modules/auth/router'
import homeRouter from '../modules/sgcc/router/home'
import budgetRouter from '../modules/budgets/router'
import teacherRouter from '../modules/teachers/router'
import pecunaryRightRouter from '../modules/pecunaryRights/router'
import typesServicesRouter from '../modules/typesOfService/router'
import typesSubjectsRouter from '../modules/typesOfSubject/router'
import cohortsRouter from '../modules/cohorts/router'

import isAuthenticatedGuard from '../modules/auth/router/auth-guard'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'auth.login' }
  },
  {
    path: '/auth',
    beforeEnter: [ isAuthenticatedGuard ],
    ...authRouter
  },
  {
    path: '/home',
    beforeEnter: [ isAuthenticatedGuard ],
    ...homeRouter
  },
  {
    path: '/presupuestos',
    beforeEnter: [ isAuthenticatedGuard ],
    ...budgetRouter
  },
  {
    path: '/docentes',
    beforeEnter: [ isAuthenticatedGuard ],
    ...teacherRouter
  },
  {
    path: '/derechos-pecunarios',
    beforeEnter: [ isAuthenticatedGuard ],
    ...pecunaryRightRouter
  },
  {
    path: '/tipos-servicios',
    beforeEnter: [ isAuthenticatedGuard ],
    ...typesServicesRouter
  }, 
  {
    path: '/tipos-materias',
    beforeEnter: [ isAuthenticatedGuard ],
    ...typesSubjectsRouter
  },
  {
    path: '/cohortes',
    beforeEnter: [ isAuthenticatedGuard ],
    ...cohortsRouter
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  const { toCamelCase } = useFunctions()
  document.title = `${ process.env.VUE_APP_TITLE } -  ${ toCamelCase(to.path.split('/').filter(item => item !== '')[0]) }`
})

export default router
